export default __webpack_public_path__ + "static/media/2x3.33aa0509.svg";